module.exports = __webpack_public_path__ + "static/pic07-96f380221320828680f2d9a36e7fd589.jpeg";